export default __webpack_public_path__ + "static/media/sqmi.8ec68e16.svg";